import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { lazy, Suspense, useContext, useEffect, useState } from 'react';
import { Switch, Route } from 'react-router-dom';
import Loader from '../Loader/Loader';

import ContactInformation from '../LeadGeneration/StepOne/ContactInformation';

import BeneficiaryContent from '../LeadGeneration/ProductQuestion/BeneficiaryContent';

import { useFlowContext } from '../commonCode';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import LoginPageInternal from '../../WebComponents/ExpressWC/InternalTesting/LoginPageInternal';
import DummyPageInternal from '../../WebComponents/ExpressWC/InternalTesting/DummyPageInternal';
import CatalogueWCInternal from '../../WebComponents/CatalogueWC/InternalTesting/CatalogueWCInternal';
import GenerateQRInternalProduct from '../CommercialDeposit/QrCode/GenerateQRInternalProduct';
import CatalogueEntryDetails from '../../WebComponents/CatalogueWC/Components/CatalogueEntryDetails';

const Overlay = lazy(() => import('../Overlay/Overlay'));
const FormHandler = lazy(() => import('../LeadGeneration/FormHandler'));
function Routing() {
  const history = useHistory();
  const { wcData, setWcData, setCurrentPage } = useContext(LeadGenerationContext);
  const baseContext = useFlowContext();
  const [hashRoute, setHashRoute] = useState(() => window.location.hash);
  const isCatalogueExpressOpening = /^#\/ExpressAccOpening(?:\?|$)/.test(hashRoute);

  useEffect(() => {
    const updateProductDetailsFromHash = (hash) => {
      setHashRoute(hash);

      if (!/^#\/ExpressAccOpening(?:\?|$)/.test(hash)) {
        return;
      }

      const queryString = hash.includes('?') ? hash.substring(hash.indexOf('?') + 1) : '';
      const params = new URLSearchParams(queryString);
      const productName = params.get('productName') || '';
      const productType = params.get('productType') || '';
      setWcData((prev) => ({
        ...(prev || {}),
        productName,
        productType,
      }));
    };

    const onHashChange = () => {
      updateProductDetailsFromHash(window?.location?.hash);
    };

    const catalogueExpressOpen = (e) => {
      setWcData((prev) => ({
        ...(prev || {}),
        ...(e?.detail || {}),
      }));
    };

    const onOffers = (e) => {
      setWcData(e?.detail);
      history.push('/test-login-inline');
    };

    const hideHeader = (e) => {
      setCurrentPage('dummywc');
    };

    window.addEventListener('offers-product-wc', onOffers);
    window.addEventListener('catalogue-express-initialization', catalogueExpressOpen);
    window.addEventListener('hide-header', hideHeader);
    window.addEventListener('hashchange', onHashChange);

    updateProductDetailsFromHash(window?.location?.hash);

    return () => {
      window.removeEventListener('offers-product-wc', onOffers);
      window.removeEventListener('catalogue-express-initialization', catalogueExpressOpen);
      window.removeEventListener('hide-header', hideHeader);
      window.removeEventListener('hashchange', onHashChange);
    };
  }, []);

  return (
    <div style={{ height: '100%' }}>
      {isCatalogueExpressOpening ? (
        <LoginPageInternal wcData={wcData} />
      ) : (
        <Suspense
          fallback={
            <div className="loader-style">
              <Loader />
            </div>
          }
        >
          <Switch>
            <Route
              exact
              path="/:region/:lang/:journeyType/:product/:page/"
              component={FormHandler}
            />
            <Route
              exact
              path="/:region/:lang/express/:journeyType/:product/:page/"
              component={FormHandler}
            />
            <Route exact path="/:region/:lang/:journeyType/:page/" component={FormHandler} />
            <Route exact path="/:region/:lang/:product/:page/" component={FormHandler} />
            <Route exact path="/:lang/:journeyType/:page/" component={FormHandler} />
            <Route exact path="/:lang/:page/" component={FormHandler} />
            <Route exact path="/:region/:lang/:page/" component={FormHandler} />
            <Route exact path="/" component={Overlay} />
            <Route exact path="/bundle" component={BeneficiaryContent} />
            {/* <Route exact path="/loader" component={LoaderCarousel} /> */}
            <Route exact path="/cd-success" component={GenerateQRInternalProduct} />
            <Route
              exact
              path="/test-login-inline"
              render={(routeProps) => <LoginPageInternal {...routeProps} wcData={wcData} />}
            />
            <Route
              exact
              path="/test-dummy-inline/"
              render={(routeProps) => <DummyPageInternal {...routeProps} />}
            />
            <Route
              exact
              path="/catalogue-entry-info"
              render={(routeProps) => <CatalogueEntryDetails {...routeProps} />}
            />
            <Route
              exact
              path="/catalogue-wc"
              render={(routeProps) => <CatalogueWCInternal {...routeProps} />}
            />
          </Switch>
        </Suspense>
      )}
    </div>
  );
}

export default Routing;
